import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import AppHeaderLanguage from './components/AppHeaderLanguage';
import AppHeader from './components/AppHeader';
import AppFooter from './components/AppFooter';
import HomePage from './components/HomePage';
import ProductPage from './components/ProductPage';
import ContactPage from './components/ContactPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';

const App = () => {
  const [showHeader, setShowHeader] = useState(true);
  const [showFooter, setShowFooter] = useState(true);

  const location = useLocation();

  useEffect(() => {
    // 특정 경로에서 Header와 Footer 숨기기
    if (location.pathname === '/privacy-policy') {
      setShowHeader(false);
      setShowFooter(false);
    } else {
      setShowHeader(true);
      setShowFooter(true);
    }
  }, [location]);

  return (
    <div id="app">
      {showHeader && <AppHeaderLanguage />}
      {showHeader && <AppHeader />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
      {showFooter && <AppFooter />}
    </div>
  );
};

const AppWithRouter = () => (
  <Router>
    <App />
  </Router>
);

export default AppWithRouter;
